import { gql, useApolloClient } from "@apollo/client";
import { useSnackbarApi } from "@comet/admin";
import { type CommonDeleteDialogProps, DeleteDialog } from "@src/components/dialogs/deleteDialog/DeleteDialog";
import Snackbar from "@src/components/snackbar/Snackbar";
import { type GQLRemoveCameraUserRelationAdminMutation, type GQLRemoveCameraUserRelationAdminMutationVariables } from "@src/graphql.generated";
import { type ReactElement } from "react";
import { useIntl } from "react-intl";

import { cameraQuery } from "./Camera";

const removeCameraUserRelationAdmin = gql`
    mutation RemoveCameraUserRelationAdmin($id: ID!) {
        removeCameraUserRelationAdmin(id: $id)
    }
`;

interface DeleteDeviceDialogProps extends CommonDeleteDialogProps {
    cameraId: string;
}

export const DeleteUserDeviceRelationDialog = ({ cameraId, handleClose, ...restProps }: DeleteDeviceDialogProps): ReactElement => {
    const client = useApolloClient();
    const snackbarApi = useSnackbarApi();
    const intl = useIntl();

    const submit = async () => {
        await client.mutate<GQLRemoveCameraUserRelationAdminMutation, GQLRemoveCameraUserRelationAdminMutationVariables>({
            mutation: removeCameraUserRelationAdmin,
            variables: { id: cameraId },
            refetchQueries: [{ query: cameraQuery, variables: { id: cameraId } }],
        });
        handleClose();

        snackbarApi.showSnackbar(
            <Snackbar
                variant="success"
                message={intl.formatMessage({
                    id: "reviermanager.camera.delete.user.success",
                    defaultMessage: "Benutzerverknüpfung wurde gelöscht",
                })}
                key="reviermanager.camera.delete.user"
                handleClose={snackbarApi.hideSnackbar}
            />,
        );
    };

    return <DeleteDialog {...restProps} handleClose={handleClose} submit={submit} />;
};
